import { useEffect, useState } from "react";
import { useEvent } from "react-use";
import { useWindowSize } from "./useWindowSize";

export const useParallaxCaption = (start: number, manualOffset: number = 0) => {
  const [show, setShow] = useState(false);
  const [offset, setOffset] = useState<number | undefined>(undefined);
  const height = useWindowSize().height;

  useEffect(() => {
    const reference = document.querySelector("#section-innovation");
    if (reference) {
      setOffset(
        reference.getBoundingClientRect().top + window.scrollY - height
      );
    }
  }, [height]);

  useEvent(
    "scroll",
    () => {
      if (offset != null) {
        if ((window.scrollY - offset - manualOffset) / height >= start) {
          setShow(true);
        } else {
          setShow(false);
        }
      }
    },
    window,
    { passive: true }
  );

  return show;
};
